import { Request } from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import { getMiddlewareUrl } from "@campgladiator/cg-common.config.config";
import { Customer, DefaultPaymentMethod } from "./stripe";

type fetchStripeSetupIntentProps = {
  clientSecret: string;
  id: string;
};

type StripePaymentMethodsResponse = {
  data: DefaultPaymentMethod[];
};

type StripeCustomerResponse = Customer;

export const fetchStripeCreateSetupIntent = async (
  customerId: string
): Promise<fetchStripeSetupIntentProps> => {
  const body = JSON.stringify({ customerId });

  try {
    const request: Request = {
      body,
      requestConfig: {
        method: "POST",
        url: {
          baseUrl: getMiddlewareUrl(),
          endpoint: "/create-setup-intent",
        },
      },
    };

    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? result
      : Promise.reject(result.message || result.error || "unknown error");
  } catch (error: any) {
    throw error.message;
  }
};

export const fetchStripePaymentMethods = async (
  customerId: string
): Promise<StripePaymentMethodsResponse> => {
  const body = JSON.stringify({ customerId });

  try {
    const request: Request = {
      body,
      requestConfig: {
        method: "POST",
        url: {
          baseUrl: getMiddlewareUrl(),
          endpoint: "/stripe-payment-methods",
        },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? result
      : Promise.reject(result.message || result.error || "unknown error");
  } catch (error: any) {
    throw error.message;
  }
};

export const fetchStripePublishableKey = async () => {
  try {
    const request: Request = {
      requestConfig: {
        method: "GET",
        url: {
          baseUrl: getMiddlewareUrl(),
          endpoint: "/stripe-config",
        },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? result
      : Promise.reject(result.message || result.error || "unknown error");
  } catch (error: any) {
    throw error.message;
  }
};

export const updateStripeCustomerDefaultPaymentMethod = async (
  customerId: string,
  paymentMethodId: string
): Promise<StripeCustomerResponse> => {
  const body = JSON.stringify({
    id: customerId,
    invoice_settings: {
      default_payment_method: paymentMethodId,
    },
  });

  try {
    const request: Request = {
      body,
      requestConfig: {
        method: "POST",
        url: {
          baseUrl: getMiddlewareUrl(),
          endpoint: "/update-customer-default-payment-method",
        },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? result
      : Promise.reject(result.message || result.error || "unknown error");
  } catch (error: any) {
    throw error.message;
  }
};

export const fetchStripeCustomer = async (
  customerId: string
): Promise<StripeCustomerResponse> => {
  const body = JSON.stringify({ customerId });

  try {
    const request: Request = {
      body,
      requestConfig: {
        method: "POST",
        url: {
          baseUrl: getMiddlewareUrl(),
          endpoint: "/retrieve-customer",
        },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? result
      : Promise.reject(result.message || result.error || "unknown error");
  } catch (error: any) {
    throw error.message;
  }
};
